import parentApi from './axios/studentAxios';

export const parentStudentsListRequest = () => parentApi.get('/parents/students');

export const parentCreateStudentRequest = (data) => parentApi.post('/parents/students', data);
